/**
 * Created by JIA on 2020/7/13.
 */
import React from "react";
import PropTypes from "prop-types";
import { EnumHasFlag, GetSentenceStyleBySentenceCommand, ParseSetting } from "../../utils/MarkTextHelper";
import "../../assets/scss/components/ui/sentence.scss";
import _ from "lodash";
import Constants from "../../config/Constants";

const TranslationText = props => {
    const sentenceStyle = GetSentenceStyleBySentenceCommand(props.sentenceCommand, props.sentenceCommandSetting);
    //some style need use a class, for now its indent
    const className = sentenceStyle.sentenceClassName;

    const content = (
        <div {...props} style={{ ...sentenceStyle, fontSize: 15, ...props.style }} className={[className, props.className]}>
            {props.children}
        </div>
    );

    //to support dialog
    if (_.isNumber(props.sentenceCommand)) {
        if (EnumHasFlag(props.sentenceCommand, Constants.SENTENCE_MARK_TYPE.DIALOG)) {
            const parsedSetting = ParseSetting(props.sentenceCommandSetting);
            if (parsedSetting && parsedSetting.role) {
                if (_.toLower(parsedSetting.role) === "a" || _.toLower(parsedSetting.role) === "b") {
                    const role = _.toLower(parsedSetting.role);

                    return (
                        <div style={{ display: "flex", flexDirection: role === "a" ? "row" : "row-reverse", justifyContent: "flex-start", alignItems: "center", margin: "20px 0px" }}>
                            <div style={{ ...(role === "a" ? { marginRight: "10px" } : { marginLeft: "10px" }), flex: 1, alignSelf: "flex-start" }}>
                                <div className="avatar avatar-sm rounded-circle" style={{ ...styles.avatarStyle }}>
                                    {_.toUpper(role)}
                                </div>
                            </div>
                            <div style={{ flex: 8, display: "flex", justifyContent: role === "a" ? "flex-start" : "flex-end" }}>{content}</div>
                            <div style={{ flex: 1 }}></div>
                        </div>
                    );
                }
            }
        }
    }

    return content;
};

const styles = {
	container: {
		display: "flex",
		flexDirection: "row",
	},
	avatarStyle: {
        // backgroundColor: "#f2f2f2",
        // color: "#333"
        color: "transparent",
        backgroundColor: "transparent" //no need show the role icon
	},
};

TranslationText.propTypes = {
    sentenceCommand: PropTypes.number,
    sentenceCommandSetting: PropTypes.oneOf([PropTypes.string, PropTypes.object]),
    style: PropTypes.object,
};

TranslationText.defaultProps = {
    sentenceCommand: 1,
    sentenceCommandSetting: "",
    style: {},
};

export default TranslationText;
